<template>
  <div
    id="useful"
    class="useful-alignment"
    v-scroll-reveal
  >
    <v-container class="max-height">
      <v-row class="max-height align-center">
        <v-col
          class="max-height img-container d-none d-lg-block"
          cols="12"
          lg="6"
        >
          <v-row class="justify-center align-center">
            <img
              src="../assets/useful01.jpg"
              id="usefulImg01"
              alt=""
            >
            <div class="rect"></div>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          lg="6"
          class="d-flex justify-center px-10"
        >
          <v-row>
            <h2 class="useful-title">
              Hasznos tanácsok ingatlanvásárláshoz
            </h2>
            <div class="useful-text">
              Az itt leírtakat jó tanácsként szánom, ingatlant vásárolni szándékozóknak, hogy kitől szabad és kitől kockázatos ingatlant vásárolni.
              <br />
              <br />
              Tapasztalatainkat megosztva, nem elriasztani szeretném Őket, ha nem felhívni figyelműket, mire ügyeljenek a vásárláskor.
              <br />
              <br />
              Az ingatlan piacon sok tisztességes, megbízható beruházó és építéssel foglalkozó cég dolgozik, de sajnos, vannak akik nem ilyenek. Az itt leírtak, remélem segítséget nyújtanak kiválasztásukhoz.
              <br />
              <br />
              Ellenőrizze vagy ellenőriztesse le ügyvéddel, hogy a cég, akitől vásárolni szándékozik, valóban tulajdonosa a kiválasztott ingatlannak, és valóban a cég tulajdonosaival tárgyal a vásárlásról.
              <br />
              <br />
              Mielőtt, akár csak vételi szándéknyilatkozatot is tenne egy ingatlanra, mindenképpen találkozzon a valódi tulajdonossal, nehogy később kellemetlen meglepetés érje, hiszen nem mindegy kitől veszi a sokszor évtizedekre otthonául szolgáló ingatlant.
              <br />
              <br />
              Ingatlanjaink megvásárlásánál, későbbi vevőink közül is sokan vettek igénybe ingatlan közvetítőt, ami nem baj, de tapasztalataink alapján túlzottan hittek az általuk mondottaknak, még műszaki kérdésekben is, pedig nyugodtan, ki merem jelenteni, hogy jó, ha az ingatlanosok 10%-a ért annyira egy ingatlan műszaki és statikai felépítéséhez, hogy mérvadó legyen a véleménye. Nem a belső enteriőrre gondolok, az bármikor változtatható, viszonylag nem nagy költséggel, de ha az alapozásnál, szigetelésnél, tetőszerkezetnél vannak problémák, azokat vagy már egyáltalán nem, vagy csak rendkívül magas költséggel lehet, valahogy helyre hozni.
              <br />
              <br />
              Vevőinknek mindig felhívom a figyelmét, hogy a végső döntés előtt, nézesse meg az ingatlant műszaki szakértővel, még ha ez plusz költség is. Ma már gépkocsi vásárlásnál is egyre többen igénylik a szakember általi átvizsgálást, ami egy ingatlan vásárlásának töredéke. Adott esetben ezzel megelőzhető, egy nem megfelelő ingatlan vételéből adódó, akár évtizedekig tartó szenvedés, pereskedés stb.
              <br />
              <br />
              Ne csak az árat nézze! Jól megépített, jó környezetben lévő ingatlant, nem fog olcsón kapni!
              <br />
              <br />
              Sokan álmodoznak az ún. alkalmi vételekről, de higgyék el, az ingatlanpiacon a minőségnek ára van! Ezzel nem azt mondom, hogy, ami drága az biztosan jó is! De ami, olcsó vagy olcsóbb az átlagnál, az valószínűsíthetően, hiányosságokkal tarkított, amit a vevő, mivel laikus, nem lát és nem is láthat, mert már beépítésre, vagy éppen pont az a probléma, hogy beépítésre, nem kerültek bizonyos fontos elemei egy jól megépített és évtizedekre problémamentes háznak. „Olcsó húsnak, híg a leve”, tartja a mondás, ami nagyon is igaz az ingatlanpiacra. Ez nagyon fontos, megszívlelendő!
            </div>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style>
#useful {
  background-color: #212832;
  background-size: cover;
  min-height: 600px;
  width: 100%;
}

.max-height {
  height: 100%;
}

#usefulImg01 {
  z-index: 10;
  width: 25vw;
  max-width: 600px;
  -webkit-box-shadow: 10px 10px 30px -12px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 10px 10px 30px -12px rgba(0, 0, 0, 0.75);
  box-shadow: 10px 10px 30px -12px rgba(0, 0, 0, 0.75);
}

.rect {
  content: "";
  z-index: 9;
  position: absolute;
  width: 25vw;
  max-width: 450px;
  height: 30vw;
  max-height: 500px;
  background-color: transparent;
  border: 5px solid grey;
}

.useful-alignment {
  display: flex;
  align-items: center;
}

.img-container {
  position: relative;
}

.useful-title {
  margin-top: 2rem;
  margin-bottom: 1.5rem;
  font-size: 2rem;
  color: #d3b364;
  font-weight: normal;
}

.useful-text {
  text-align: justify;
  font-size: 1.1rem;
  font-weight: 300;
  margin: 0 3rem 2rem 0;
}

@media screen and (min-width: 601px) and (max-width: 1264px) {
  .useful-text {
    margin: 0 0 2rem 0;
  }
  .useful-title {
    margin-top: 2rem;
    text-align: center;
    width: 100%;
  }
}

@media screen and (max-width: 600px) {
  .useful-title {
    margin-top: 2rem;
    text-align: center;
    width: 100%;
  }
  .useful-text {
    margin: 0 0 2rem 0;
  }
}
</style>


<script>
export default {};
</script>
